import { render, staticRenderFns } from "./edutalk-aside.vue?vue&type=template&id=ecac869c"
import script from "./edutalk-aside.vue?vue&type=script&lang=js"
export * from "./edutalk-aside.vue?vue&type=script&lang=js"
import style0 from "./edutalk-aside.vue?vue&type=style&index=0&id=ecac869c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports